import { useEffect, useState }     from 'react';
import { Typography, useTheme }    from '@mui/material';
import { RoutePlaceHolderWrapper } from '@styles/Shared/StyledRoutePlaceHolder';
import { PhoenixGrid }             from './grid/PhoenixGrid';

export const RoutePlaceholder = ({ title }: { title: string }) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const timeoutId = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [title]);

  return (
    <>
      <Typography variant="h3" color={theme.palette.primary.dark} sx={{ m: '25px 20px' }}>
        {title}
      </Typography>

      <RoutePlaceHolderWrapper>
        <PhoenixGrid columns={[]} rows={[]} loading={loading} />
      </RoutePlaceHolderWrapper>
    </>
  );
};
